import axios from 'axios'
import { getCookieValue } from '../common-services'
import { BASE_URL } from './../../config'

export const getAllSession = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/getCommonData.php?schoolCode=${schoolCode}&loginId=${loginId}&getSessions=1`,
    )
  } catch (err) {
    console.log(err.message)
  }
}

export const getCertificatesTableData = async (classes, section, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/CertificateControl_1.php?get_student_by_class_session=1&school=1&session=${session}&class=${classes}&sec_id=${section}&schoolCode=${schoolCode}&loginId=${loginId}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting certificates issue  tabel data', err.message) // Handle errors
  }
}

export const getSubCertificatesOptions = async (type) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/certificates/getCertificatesData.php?schoolCode=${schoolCode}&loginId=${loginId}&getCertificateName=1&type=${type}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting sUB certificates options', err.message) // Handle errors
  }
}

export const generateCertificateAPI = async ({
  certificate_type,
  Student_Id,
  Session,
  date_of_issue,
  reason,
  bonafide_name,
}) => {
  try {
    return await axios.get(
      `${BASE_URL}/GenerateCertificate.php?certificate_type=${certificate_type}&Student_Id=${Student_Id}&Session=${Session}&date_of_issue=${date_of_issue}&reason=${encodeURIComponent(reason)}&bonafide_name=${bonafide_name}&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`,
    )
  } catch (err) {
    console.error('Error while generating certificate:', err.message)
  }
}

export const getCertificateType = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/certificates/getCertificatesData.php?schoolCode=${schoolCode}&loginId=${loginId}&getCertType=1`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting  certificates options', err.message)
  }
}

export const getTcSearchTableData = async (
  SearchBy,
  { studentName, fatherName, fromDate, toDate },
) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  if (SearchBy == 'IssueDate') {
    try {
      return await axios.get(
        `${BASE_URL}/api-controller/certificates/getcertificatesData.php?schoolCode=${schoolCode}&loginId=${loginId}&getTCData=1&searchType=${SearchBy}&fromDate=${fromDate}&toDate=${toDate}`,
      ) // Replace with your API endpoint
    } catch (err) {
      console.log('Error while getting Tc search table data', err.message)
    }
  } else if (SearchBy == 'studentName') {
    try {
      return await axios.get(
        `${BASE_URL}/api-controller/certificates/getcertificatesData.php?schoolCode=${schoolCode}&loginId=${loginId}&getTCData=1&searchType=${SearchBy}&studentName=${studentName}`,
      ) // Replace with your API endpoint
    } catch (err) {
      console.log('Error while getting Tc search table data', err.message)
    }
  } else if (SearchBy == 'fatherName') {
    try {
      return await axios.get(
        `${BASE_URL}/api-controller/Certificates/getCertificatesData.php?schoolCode=${schoolCode}&loginId=${loginId}&getTCData=1&searchType=${SearchBy}&fatherName=${fatherName}`,
      ) // Replace with your API endpoint
    } catch (err) {
      console.log('Error while getting Tc search table data', err.message)
    }
  }
}

export const getTCFields = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/certificates/getCertificatesData.php?schoolCode=${schoolCode}&loginId=${loginId}&getTCFields=1`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting  tc fields', err.message)
  }
}

export const updateTCFields = async (formData) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/certificates/getcertificatesData.php?schoolCode=${schoolCode}&loginId=${loginId}`,
      formData,
    )
  } catch (err) {
    console.log('Error while sending data', err.message)
  }
}

export const checkCertificateAllowance = async (studentId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/certificates/getcertificatesData.php?schoolCode=${schoolCode}&loginId=${loginId}&checkIsTCAllowed=1&studentId=${studentId}&session=${session}`,
    )
  } catch (err) {
    console.log('Error while getting data', err.message)
  }
}

export const insertCertificateIssuedReport = async (formData) => {
  try {
    return await axios.post(`${BASE_URL}/TCImportBulk1.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`, formData)
  } catch (err) {
    console.log('Error while sending data', err.message)
  }
}

export const getCertificateName = async () => {
  try {
    return await axios.get(`${BASE_URL}/GetCertificateName.php?Type=Character&schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`)
  } catch (err) {
    console.log('Error while getting certificate name')
  }
}

export const insertCharacterBulk = async (formData) => {
  try {
    return await axios.post(`${BASE_URL}/CharacterBulkImport1.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`, formData)
  } catch (err) {
    console.log('Error while inserting data', err.message)
  }
}

export const insertBulkSLCCertificateIssuedReport = async (formData) => {
  try {
    return await axios.post(`${BASE_URL}/SLCImportBulk1.php?schoolCode=${getCookieValue('schoolCode')}&loginId=${getCookieValue('loginId')}`, formData)
  } catch (err) {
    console.log('Error while inserting data', err.message)
  }
}

export const getAllowedStudentsTcTableData = async (classId, section, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/certificates/getcertificatesData.php?schoolCode=${schoolCode}&loginId=${loginId}&getAllowedStudentTC=1&classId=${classId}&secId=${section}&session=${session}`,
    )
  } catch (err) {
    console.log('Error while getting certificate name')
  }
}

export const saveTcApproval = async (formData) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.post(
      `${BASE_URL}/api-controller/certificates/getcertificatesData.php?schoolCode=${schoolCode}&loginId=${loginId}&`,
      formData,
    )
  } catch (err) {
    console.log('Error while inserting data', err.message)
  }
}

export const grantStudentTC = async (studentId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/certificates/getcertificatesData.php?schoolCode=${schoolCode}&loginId=${loginId}&studentTCFeeSettlement=1&studentId=${studentId}&session=${session}`,
    )
  } catch (err) {
    console.log('Error while grant TC')
  }
}

export const resumeTc = async (studentId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/certificates/getcertificatesData.php?schoolCode=${schoolCode}&loginId=${loginId}&studentTCResume=1&studentId=${studentId}&session=${session}`,
    )
  } catch (err) {
    console.log('Error while resume TC')
  }
}

export const getTCField = async (studentId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/api-controller/certificates/getcertificatesData.php?schoolCode=${schoolCode}&loginId=${loginId}&getTCFieldsByStudent=1&studentId=${studentId}&session=${session}`,
    )
  } catch (err) {
    console.log('Error while fetching data ', err)
  }
}

export const updateTCField = async (formData) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formData.append('schoolCode', schoolCode) // Step 7: Add the school code to FormData
  formData.append('loginId', loginId)

  try {
    return await axios.post(
      `${BASE_URL}/api-controller/certificates/getcertificatesData.php`,
      formData,
    )
  } catch (err) {
    console.error('Error while updating data', err)
  }
}

export const getSLCField = async (studentId, session) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  try {
    return await axios.get(
      `${BASE_URL}/api-controller/certificates/getcertificatesData.php?schoolCode=${schoolCode}&loginId=${loginId}&getSLCFieldsByStudent=1&studentId=${studentId}&session=${session}`,
    )
  } catch (err) {
    console.log('Error while fetching data ', err)
  }
}

export const updateSLCField = async (formData) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  formData.append('schoolCode', schoolCode) // Step 7: Add the school code to FormData
  formData.append('loginId', loginId)

  try {
    return await axios.post(
      `${BASE_URL}/api-controller/certificates/getcertificatesData.php`,
      formData,
    )
  } catch (err) {
    console.error('Error while updating data', err)
  }
}

export const getCertSections = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/certificates/getCertificatesData.php?schoolCode=${schoolCode}&loginId=${loginId}&getCertSections=1&`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting  tc fields', err.message)
  }
}

export const getCertSectionsbyStudent = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/certificates/getCertificatesData.php?schoolCode=${schoolCode}&loginId=${loginId}&getCertSections=1&Certificate_Use=student`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting  tc fields', err.message)
  }
}

export const getConfigureOtherCertificate = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/certificates/getCertificatesData.php?schoolCode=${schoolCode}&loginId=${loginId}&getOtherCertConfig=1`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting  tc fields', err.message)
  }
}

export const createConfigureOtherCertificate = async ({
  certSections,
  session,
  section1,
  section2,
  section3,
  footer1,
  footer2,
  footer3,
}) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  const fd = new FormData()

  fd.append('insertCertificateConfiguration', '1')

  fd.append('certSections', certSections)
  fd.append('session', session)
  fd.append('content1', section1)
  fd.append('content2', section2)
  fd.append('content3', section3)
  fd.append('footer1', footer1)
  fd.append('footer2', footer2)
  fd.append('footer3', footer3)

  fd.append('schoolCode', schoolCode)
  fd.append('loginId', loginId)

  try {
    return await axios.post(
      `${BASE_URL}/api-controller/certificates/getcertificatesData.php`,
      fd,
    )
  } catch (err) {
    console.log('Error while sending data', err.message)
  }
}

export const EditConfigureOtherCertificates = async ({
  certSections,
  session,
  section1,
  section2,
  section3,
  footer1,
  footer2,
  footer3,
  id,
}) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  const fd = new FormData()

  fd.append('updateCertificateConfiguration', '1')

  fd.append('CF_ID', id)
  fd.append('certSections', certSections)
  fd.append('session', session)
  fd.append('content1', section1)
  fd.append('content2', section2)
  fd.append('content3', section3)
  fd.append('footer1', footer1)
  fd.append('footer2', footer2)
  fd.append('footer3', footer3)

  fd.append('schoolCode', schoolCode)
  fd.append('loginId', loginId)

  try {
    return await axios.post(
      `${BASE_URL}/api-controller/certificates/getcertificatesData.php`,
      fd,
    )
  } catch (err) {
    console.log('Error while sending data', err.message)
  }
}

export const deleteConfigureOtherCertificate = async (CF_Id) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/certificates/getCertificatesData.php?schoolCode=${schoolCode}&loginId=${loginId}&cancelCertConfig=1&enabled=0&CF_Id=${CF_Id}`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting  tc fields', err.message)
  }
}

export const getConfigureCertificate = async () => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')
  try {
    return await axios.get(
      `${BASE_URL}/api-controller/certificates/getCertificatesData.php?schoolCode=${schoolCode}&loginId=${loginId}&getCertConfig=1&CertificateUse=Student`,
    ) // Replace with your API endpoint
  } catch (err) {
    console.log('Error while getting  tc fields', err.message)
  }
}

export const createConfigureCertificate = async ({
  certificateType,
  certificateName,
  feeHead,
  section1,
  section2,
  section3,
  footer1,
  footer2,
  footer3,
}) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  const fd = new FormData()

  fd.append('insertCertificateConfiguration', '1')

  fd.append('content1', section1)
  fd.append('content2', section2)
  fd.append('content3', section3)
  fd.append('footer1', footer1)
  fd.append('footer2', footer2)
  fd.append('footer3', footer3)
  fd.append('certificateType', certificateType)
  fd.append('CertificateName', certificateName)
  fd.append('includeFeeheads', feeHead)

  fd.append('schoolCode', schoolCode)
  fd.append('loginId', loginId)

  try {
    return await axios.post(
      `${BASE_URL}/api-controller/certificates/getcertificatesData.php`,
      fd,
    )
  } catch (err) {
    console.log('Error while sending data', err.message)
  }
}

export const EditConfigureCertificates = async ({
  certificateType,
  certificateName,
  feeHead,
  section1,
  section2,
  section3,
  footer1,
  footer2,
  footer3,
  id,
}) => {
  const schoolCode = getCookieValue('schoolCode')
  const loginId = getCookieValue('loginId')

  const fd = new FormData()

  fd.append('updateCertificateConfiguration', '1')

  fd.append('CF_ID', id)
  fd.append('content1', section1)
  fd.append('content2', section2)
  fd.append('content3', section3)
  fd.append('footer1', footer1)
  fd.append('footer2', footer2)
  fd.append('footer3', footer3)
  fd.append('certificateType', certificateType)
  fd.append('CertificateName', certificateName)
  fd.append('includeFeeheads', feeHead)

  fd.append('schoolCode', schoolCode)
  fd.append('loginId', loginId)

  try {
    return await axios.post(
      `${BASE_URL}/api-controller/certificates/getcertificatesData.php`,
      fd,
    )
  } catch (err) {
    console.log('Error while sending data', err.message)
  }
}
